module.exports = __webpack_public_path__ + "img/22.e226fc51.jpg";